<script lang="ts" setup>
import NewCatalogMenuItem from '~/components/new-catalog-menu/NewCatalogMenuItem.vue'
import type { NewCategoryMenuItem } from '~/types/menus'

defineProps<{
  data: NewCategoryMenuItem[]
}>()
</script>

<template>
  <div
    v-for="(x, i) in data"
    :key="i"
    class="inline-block w-full"
    itemprop="hasPart"
    itemscope
    itemtype="https://schema.org/ListItem"
  >
    <NewCatalogMenuLink class="font-medium !text-main-green" :data="x" is-parent />

    <ul class="mb-4 mt-2 md:mb-6 md:mt-4">
      <NewCatalogMenuItem :items="x.items" />
    </ul>
  </div>
</template>
